import clsx from "clsx";
import { useEffect } from "react";
import { PostRaiting } from "..";
import { TopicPopup, useTopicsModalQuery } from "../../features";
import s from "./trending.module.css";

type Props = {
  data: any;
  number: number;
  className?: string;
  referenceId?: string;
  tonal?: string;
  onlyFederal?: boolean;
  updateData?: any
};

export const Trend = ({ number, className, data, referenceId, tonal, onlyFederal, updateData}: Props) => {

  useEffect(() => {
    const listOfSources = data.details.items.filter((it: any) => it.smi_type === "federal")
    updateData(data['federal']=listOfSources?.length)

    const postsFederal = {
        id:data?.id ,
        federal: postFederal,

      }
    //updateFederal(postsFederal)
  }, [data]);

  const postRatingData = {
    id: data.id,
    group_id: data.group_id,
    topic: data.title,
    subject: data.reference_item,
    level: 0,
    subjectPublications: data.details.items.length,
    subjectCoverage: data.attendance,
    totalPublications: data.owners_count,
    totalCoverage: data.total_attendance,
    dynamicData: data.graph,
    mediaPublications: data.smi_total_posts,
    socialMediaPublications: data.social_total_posts,
    publications: data.details
  };

  const postNetural = data.details.items.filter((it: any) => it.trust.trust === 0).length;
  const postNegative = data.details.items.filter((it: any) => it.trust.trust === -1).length;
  const postPositive = data.details.items.filter((it: any) => it.trust.trust === 1).length;
  const postSumm = postNetural + postNegative + postPositive;
  tonal = postNegative*100/postSumm >= 25 ? 'trending_negative' : postPositive*100/postSumm >= 25 ? 'trending_positive' : ''
  const postFederal = data.details.items.filter((it: any) => it.smi_type === "federal") || [];

  const content = (
    <div className={className}>
      {(onlyFederal && postFederal.length > 0)  &&
      <PostRaiting
        number={number}
        coat={postFederal.length > 0}
        className={clsx(s.topic, s[tonal])}
        data={postRatingData}
      />
      }
      {(!onlyFederal)  &&
      <PostRaiting
        number={number}
        coat={postFederal.length > 0}
        className={clsx(s.topic, s[tonal])}
        data={postRatingData}
      />
      }
    </div>
  );

  return <TopicPopup isTrending={true} content={content} data={postRatingData} referenceId={referenceId} profileId='all'/>;
};
